import { type CSSProperties, type FunctionComponent } from "react";

import { LoadingSkeleton } from "../../../general/LoadingSkeleton";
import { Shelf, Stack } from "../../../layout";
import { InputContainerPlaceholder } from "../../shared/InputContainer/InputContainerPlaceholder";
import type { RTEPlaceholderDefs } from "../RichTextEditorProps";
import { getBaseDefsFromHtmlProps } from "../utils/getBaseDefsFromHtmlProps";
import { getHtmlDefsFromBaseProps } from "../utils/getHtmlDefsFromBaseProps";

import CSS from "../styles.module.css";

const SEPARATOR_STYLE: CSSProperties = { width: 2, height: 24, opacity: 0.5 };
const BUTTON_STYLE: CSSProperties = { width: 24, height: 24 };
const FIELD_STYLE: CSSProperties = { height: 128 };

const Divider: FunctionComponent = () => {
  return <LoadingSkeleton style={SEPARATOR_STYLE} />;
};

export const Loader: FunctionComponent<RTEPlaceholderDefs> = (props) => {
  const { lines, hasInstructions = false } = props;
  const className = [CSS.RichTextEditorPlaceholder, "rich-text-editor", "placeholder", { "fixed-height": lines != null }];
  const baseHtmlDefs = getHtmlDefsFromBaseProps(props, { className, testIdPrefix: "rich-text-editor-placeholder" });

  return (
    <InputContainerPlaceholder {...getBaseDefsFromHtmlProps(baseHtmlDefs)} hasInstructions={hasInstructions}>
      <Stack spacing="mini" alignment="span" aria-hidden="true">
        <Shelf spacing="small" alignment="span" responsiveAlignment="stretch" aria-hidden="true">
          <LoadingSkeleton style={BUTTON_STYLE} />
          <LoadingSkeleton style={BUTTON_STYLE} />
          <LoadingSkeleton style={BUTTON_STYLE} />
          <LoadingSkeleton style={BUTTON_STYLE} />
          <Divider />
          <LoadingSkeleton style={BUTTON_STYLE} />
          <LoadingSkeleton style={BUTTON_STYLE} />
          <Divider />
          <LoadingSkeleton style={BUTTON_STYLE} />
          <Shelf.Spacer />
          <LoadingSkeleton style={BUTTON_STYLE} />
        </Shelf>
        <LoadingSkeleton style={FIELD_STYLE} />
      </Stack>
    </InputContainerPlaceholder>
  );
};
